import { Tooltip } from '@andritzot/metris-web-ui/data-display/tooltip';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import React from 'react';

interface TruncatedCardTextProps {
  string?: string | null;
  typographyVariant:
    | 'button'
    | 'caption'
    | 'code'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'body1'
    | 'body2'
    | 'body3'
    | 'body4'
    | 'overline'
    | 'subtitle1'
    | 'subtitle2'
    | 'inherit'
    | 'cardHeading'
    | undefined;
  isSelected?: boolean;
  maxChars?: number;
}

const TruncatedCardText: React.FC<TruncatedCardTextProps> = ({
  string,
  typographyVariant,
  isSelected = false,
  maxChars = 70,
}) => {
  const fullText = string ?? '';
  const isLong = fullText.length > maxChars;
  const shortText = isLong ? `${fullText.slice(0, maxChars)}...` : fullText;

  const mainTextColor = typographyVariant == 'cardHeading' ? 'primary.main' : 'text.secondary';
  const textColor = isSelected ? 'primary.contrastText' : mainTextColor;

  const descElement = (
    <Typography variant={typographyVariant} sx={{ px: 4, pb: 4, color: textColor }}>
      {shortText}
    </Typography>
  );

  return isLong ? (
    <Tooltip title={fullText} placement="top">
      {descElement}
    </Tooltip>
  ) : (
    descElement
  );
};

export default TruncatedCardText;
